/**
 * ComingSoon - placeholder for Phase 1C ports not yet shipped.
 *
 * Per CHAP-78. Each Phase 1C ticket (CHAP-79..89) replaces this with
 * the real ported component from omega-club.
 */
import { useLocation } from 'react-router-dom';

interface ComingSoonProps {
  title: string;
  ticket: string;
  description?: string;
}

export default function ComingSoon({ title, ticket, description }: ComingSoonProps) {
  const location = useLocation();
  return (
    <div className="space-y-3 min-w-0">
      <div className="bg-white rounded-xl border border-gray-100 p-4 sm:p-6">
        <p className="text-xs uppercase tracking-wider text-neutral font-semibold">Coming soon</p>
        <h2 className="text-navy text-xl sm:text-2xl font-bold mt-1">{title}</h2>
        {description && <p className="text-neutral text-sm mt-2">{description}</p>}
      </div>
      <div className="bg-amber-50 border border-amber-200 rounded-xl p-3 sm:p-4 text-xs sm:text-sm text-amber-800">
        <p className="font-semibold">Pending {ticket}</p>
        <p className="text-amber-700 mt-1">
          Phase 1C component port. Route <code className="font-mono text-amber-900">{location.pathname}</code> is wired but the omega-club component port has not landed yet.
        </p>
      </div>
    </div>
  );
}
